import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';

import { ExperienceRatingV2Component } from './experience-rating-v2.component';
import { CommonModule } from '@angular/common';
import { ModalRateYourExperienceComponent } from './modal-rate-your-experience/modal-rate-your-experience.component';
import { SharedModule } from '@app/shared/shared.module';
import { FormsModule } from '@angular/forms';
import { RatingLevelSelectorComponent } from './rating-level-selector/rating-level-selector.component';
import { RatingScoreSelectorComponent } from './rating-score-selector/rating-score-selector.component';
import { ModalRateSuccessComponent } from './modal-rate-success/modal-rate-success.component';

@NgModule({
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    declarations: [ExperienceRatingV2Component, ModalRateYourExperienceComponent, RatingLevelSelectorComponent, RatingScoreSelectorComponent, ModalRateSuccessComponent],
    imports: [
        CommonModule,
        FormsModule,
        SharedModule,
    ],
    exports: [ExperienceRatingV2Component],
    providers: [],
})
export class ExperienceRatingV2Module { }
